import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const LogoImageGroupContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
  gap: 20px;
  margin-bottom: 12px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    gap: 36px;
    margin-bottom: 20px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-bottom: 28px;
  }
`;

export const LogoImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const LogosButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 10px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: -4px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-top: -12px;
  }
`;
